module.exports = __webpack_public_path__ + "img/Pier_pass_create_mobile_3.0a16ee8f.gif";